
import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/components/Modals/ModalComponent.vue';
import DateSelector from '@/components/Forms/Elements/DateSelectorComponent.vue';
import SocialSecurity from '@/components/Forms/Elements/SocialSecurityComponent.vue';
import TextInput from '@/components/Forms/Elements/TextInputComponent.vue';
import PhoneInput from '@/components/Forms/Elements/PhoneInputComponent.vue';
import { IFormState, FormInputState } from '@/models/Forms/FormState';
import Regex from '@/models/Forms/Regex';
import { selectElementContents } from '@/util/download-csv';
import { EUserRoles } from '../../../enums';
import { Recruiter } from '@/models/Entities/Personas/Recruiter';

@Component<CreateRecruiterModalComponent>({
  components: {
    DateSelector,
    Modal,
    PhoneInput,
    SocialSecurity,
    TextInput
  }
})
export default class CreateRecruiterModalComponent extends Vue {
  @Prop({ default: '' })
  readonly size!: string;

  recruiter: Recruiter = new Recruiter();
  formState: IFormState = {};
  Regex = Regex;
  show = false;
  resolve: any = () => void 0;
  reject: any = () => void 0;
  isLoading = false;
  inviteLinkUrl = '';
  recruiterCreated = false;

  close(): void {
    this.show = false;
    this.recruiter = new Recruiter();
    this.recruiterCreated = false;
    this.inviteLinkUrl = '';
  }

  public open(): Promise<any> {
    this.show = true;
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async createRecruiter(): Promise<void> {
    this.isLoading = true;
    try {
      const recruiter = await this.$store.dispatch(
        'recruiterModule/create',
        this.recruiter
      );

      this.inviteLinkUrl = await this.$store.dispatch(
        'userModule/fetchInvitation',
        {
          userEmail: recruiter.contactInformationEmail,
          userRole: EUserRoles.RECRUITER,
          entityId: recruiter.id
        }
      );
      this.recruiterCreated = true;
    } catch (err: unknown) {
      console.log('error creating recruiter', err);
    }
    this.isLoading = false;
  }

  copyAndClose(): void {
    try {
      const inviteUrlContainer = this.$refs['inviteUrlContainer'];
      selectElementContents(inviteUrlContainer);
      this.resolve(this.recruiter);
    } catch {
      this.reject('There was an error copying the recruiter invite URL');
    }
    this.close();
  }

  cancel(): void {
    this.reject();
    this.close();
  }

  updateFormState(inputName: string, inputState: FormInputState): void {
    this.$set(this.formState, inputName, inputState);
  }

  get valid(): boolean {
    return (
      Object.values(this.formState).findIndex((item) => !item.isValid) === -1 &&
      !this.isLoading
    );
  }
}
